<div class="add-note-content" (click)="preventPanelClosing($event)">
    <!-- user -->
    <div class="user-info">
        <div class="picture">
            <img *ngIf="user?.image?.file" [src]="user?.image?.file | isAuthImage | async" class="pic" />
            <mat-icon *ngIf="!user?.image?.file" svgIcon="user" class="pic icon mat-24"></mat-icon>
        </div>

        <div>{{user.str}}</div>
    </div>

    <!-- editor -->
    <div class="editor-container">
        <quill-editor [(ngModel)]="quillEditorText" placeholder="{{ 'note_dataXp_placeholder' | translate }}"
            [modules]="quillConfig" [required]="true">
        </quill-editor>
    </div>

    <!-- period -->
    <div class="period-container">
        <div class="is-body2" style="margin-bottom: 5px;">{{'view_note_data_experience' | translate}}</div>
        <!-- from -->
        <span class="is-body2">{{'from' | translate | lowercase}}</span>
        <mat-form-field appearance="outline"
            style="width: 33%; margin-right: 10px; margin-left: 10px; margin-bottom: 5px;">
            <input matInput class="is-body2" [matDatepicker]="fromPicker"
                placeholder="{{ 'always' | translate | lowercase }}" [formControl]="dateFrom" autocomplete="off"
                [max]="dateTo?.value">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
        <ng-container *ngIf="dateFrom.value !== null">
            <mat-form-field appearance="outline" style="width: 33%; margin-right: 25%; margin-bottom: 5px;">
                <input matInput [formControl]="timeFrom" placeholder="00:00" mask="00:m0" />
            </mat-form-field>
        </ng-container>
        <!-- to -->
        <span class="is-body2" style="margin-right: 8px;"> {{'to' | translate | lowercase}}</span>
        <mat-form-field appearance="outline" style="width: 33%; margin-right: 10px; margin-left: 10px;">
            <input matInput class="is-body2" [matDatepicker]="toPicker"
                placeholder="{{ 'always' | translate | lowercase }}" [formControl]="dateTo" autocomplete="off"
                [min]="dateFrom?.value">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
        <ng-container *ngIf="dateTo.value !== null">
            <mat-form-field appearance="outline" style="width: 33%; margin-right: 10px;">
                <input matInput [formControl]="timeTo" placeholder="23:59" mask="00:m0" />
            </mat-form-field>
        </ng-container>
    </div>

    <!-- actions -->
    <div class="buttons-container">
        <button mat-button class="view-note-button" style="margin-right: 20px;" (click)="cancel($event)">
            <span>{{'cancel' | translate | uppercase}}</span>
        </button>
        <button mat-flat-button color="primary" class="view-note-button" [disabled]="setSubmitDisabled()"
            (click)="submit($event)">
            <span>{{'save' | translate | uppercase}}</span>
        </button>
    </div>
</div>